module.exports = "/images/vendor/flag-icon-css/flags/4x3/gl.svg?2490aa08f40830bae35da50d6e38dbd5";